export default "/_next/static/images/ai-designer-modal-4eaea92867fc50e7c8f285327620f320.png";